import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";

const TESTIMONIALS = [
    {
        quote: "Worked with them during lockdown — hands down the best service I've experienced from a transporter, especially when everything else was halted.",
        name: "Manoj",
        company: "Kerry Indev",
        featured: true,
    },
    {
        quote: "Been working with them for the past 8 years and truly one of the best service providers in this segment.",
        name: "Rakesh",
        company: "Exporter, Dadri",
        featured: false,
    },
];

export default function Testimonials() {
    return (
        <section className="border-t border-white/10 px-5 py-24 md:px-10 md:py-32" data-testid="testimonials-section">
            <motion.div
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="mb-14 md:mb-20"
            >
                <p className="mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-blaze md:text-xs">
                    <span className="inline-block h-2 w-2 bg-blaze" />
                    Word on the Road
                </p>
                <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight md:text-6xl">
                    What clients <span className="text-outline-faint">say about us.</span>
                </h2>
            </motion.div>

            <div className="grid gap-5 lg:grid-cols-12">
                {TESTIMONIALS.map((item, i) => (
                    <motion.figure
                        key={item.company}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                        className={`group relative flex flex-col justify-between border border-white/10 bg-panel p-8 transition-colors duration-300 hover:border-blaze/40 md:p-10 ${
                            item.featured ? "lg:col-span-7" : "lg:col-span-5"
                        }`}
                        data-testid={`testimonial-card-${i + 1}`}
                    >
                        <div>
                            <Quotes size={item.featured ? 44 : 32} weight="fill" className="mb-6 text-blaze transition-transform duration-300 group-hover:-translate-y-1" />
                            <blockquote className={`font-display uppercase leading-[1.15] tracking-tight text-white/90 ${
                                item.featured ? "text-2xl md:text-4xl" : "text-xl md:text-2xl"
                            }`}>
                                &ldquo;{item.quote}&rdquo;
                            </blockquote>
                        </div>
                        <figcaption className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6">
                            <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-blaze/50 font-display text-sm text-blaze">
                                {item.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
                            </span>
                            <div>
                                <p className="text-sm font-semibold text-white">{item.name}</p>
                                <p className="text-xs uppercase tracking-[0.2em] text-white/40">{item.company}</p>
                            </div>
                        </figcaption>
                        <span className="pointer-events-none absolute bottom-0 left-0 h-0.5 w-0 bg-blaze transition-[width] duration-500 group-hover:w-full" />
                    </motion.figure>
                ))}
            </div>
        </section>
    );
}
